export default __webpack_public_path__ + "static/media/physicalwrack.ce1f33e8.png";